import TableCellTiptap from '@tiptap/extension-table-cell';

export const TableCell = TableCellTiptap.extend({
  addAttributes() {
    return {
      colspan: { default: 1 },
      rowspan: { default: 1 },
      // Legacy attribute kept for backward compatibility with existing documents.
      'data-border-width': { default: null },
      'data-border-width-top': { default: null },
      'data-border-width-bottom': { default: null },
      'data-border-width-left': { default: null },
      'data-border-width-right': { default: null },
      'data-border-color': { default: '#000' },
      'data-border-style': { default: 'solid' },
      style: {
        renderHTML(attributes) {
          const legacy = attributes['data-border-width'];
          const color = attributes['data-border-color'];
          const borderStyle = attributes['data-border-style'];
          const legacyNum = legacy !== null ? Number(legacy) : 1;

          const widthTop =
            attributes['data-border-width-top'] !== null ? Number(attributes['data-border-width-top']) : legacyNum;
          const widthBottom =
            attributes['data-border-width-bottom'] !== null
              ? Number(attributes['data-border-width-bottom'])
              : legacyNum;
          const widthLeft =
            attributes['data-border-width-left'] !== null ? Number(attributes['data-border-width-left']) : legacyNum;
          const widthRight =
            attributes['data-border-width-right'] !== null ? Number(attributes['data-border-width-right']) : legacyNum;

          const borderTop = widthTop === 0 ? 'none' : `${widthTop}px ${borderStyle} ${color}`;
          const borderBottom = widthBottom === 0 ? 'none' : `${widthBottom}px ${borderStyle} ${color}`;
          const borderLeft = widthLeft === 0 ? 'none' : `${widthLeft}px ${borderStyle} ${color}`;
          const borderRight = widthRight === 0 ? 'none' : `${widthRight}px ${borderStyle} ${color}`;

          return {
            style: `border-top: ${borderTop}; border-bottom: ${borderBottom}; border-left: ${borderLeft}; border-right: ${borderRight};`,
          };
        },
      },
    };
  },
});
